<template>
  <div>
    <v-dialog
      :value="enableDialog"
      max-width="720"
      persistent
      scrollable
      @keydown.esc="closeButtonClickEvent"
      @close="closeButtonClickEvent"
    >
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>処理後物詳細</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pt-2">
          <v-row>
            <v-col cols="6">
              <div class="overline">
                コード
              </div>
              <h4>{{ this.forms.code }}&nbsp;</h4>
              <v-divider />
            </v-col>
            <v-col cols="6">
              <v-checkbox
                v-model="forms.invisible"
                class="float-end"
                dense
                hide-details="auto"
                label="非表示にする"
                disabled
              />
            </v-col>
          </v-row>

          <h2 class="primary--text font-weight-medium ml-1 mt-3 mb-2">処理後物分類</h2>

          <v-row>
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                name="種別"
                rules="required"
              >
                <v-radio-group
                  v-model="forms.after_type"
                  :error-messages="errors"
                  hide-details="auto"
                  row
                  disabled
                >
                  <v-radio
                    value="after_industrial"
                    label="廃棄物"
                  />
                  <v-radio
                    value="after_recycling"
                    label="再資源化物"
                  />
                </v-radio-group>
              </validation-provider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="overline">
                処理後物の大分類名称
              </div>
              <h4>{{ this.forms.after_disposal_item_major_name }}&nbsp;</h4>
              <v-divider />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="overline">
                処理後物の種類
              </div>
              <h4>{{ this.forms.after_disposal_item_name }}&nbsp;</h4>
              <v-divider />
            </v-col>
          </v-row>


          <h2 class="primary--text font-weight-medium ml-1 mt-3 mb-2">細分類</h2>

          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="forms.use_subclass"
                dense
                hide-details="auto"
                label="細分類を設定"
                disabled
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="overline">
                細分類コード
              </div>
              <h4>{{ this.forms.subclass_code }}&nbsp;</h4>
              <v-divider />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="overline">
                処理後物の種類
              </div>
              <h4>{{ this.forms.subclass_name }}&nbsp;</h4>
              <v-divider />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <div class="overline">
                表示順
              </div>
              <h4>{{ this.forms.sort_priority }}&nbsp;</h4>
              <v-divider />
            </v-col>
          </v-row>

        </v-card-text>

        <v-divider />
        <v-card-actions>
          <confirmable-button
            caption="削除"
            color="error"
            modal-content="削除します。よろしいですか？"
            modal-positive-color="error"
            @negative="removeNegativeCallback"
            @positive="removePositiveCallback"
          />
          <v-spacer />
          <v-btn @click="closeButtonClickEvent">
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            :loading="loading"
            @click="editButtonClickEvent"
          >
            編集
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ConfirmableButton from "@/driver/components/ConfirmableButton.vue";

export default {
  name: "RecycleDisposalItemShowModal",
  components: {
    ConfirmableButton
  },
  props: {
    enableDialog: {
      type: Boolean,
      default: false,
    },
    targetId: {
      type: Number,
      default: () => null,
    }
  },
  data () {
    return {
      loading: false,
      forms: null,
    }
  },
  computed: {
  },
  watch: {
    enableDialog (value) {
      if (value) {
        this.initializeDialog()
      }
    },
  },
  methods: {
    // Vuex アクションのマッピング（処理後物マスタ CRUD）
    ...mapActions('DriverMasterRecycleDisposedItem', {
      showRecycleDisposedItem: "show",
      destroyRecycleDisposedItem: "destroy",
    }),
    // ダイアログ表示時の初期化（新規 or 編集データ取得 → 選択肢ロード）
    initializeDialog () {
      this.loading = true
        this.showRecycleDisposedItem({ id: this.targetId }).then((content) => {
          this.applyContent(content)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // API レスポンスをフォームに反映する
    applyContent (content) {
      if (!content) {
        return
      }

      this.forms = {
        ...this.forms,
        ...content,
      }
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('close');
    },
    /**
     * 編集ボタン クリックイベント
     */
    editButtonClickEvent () {
      this.$emit('edit');
    },
    /**
     * 削除確認モーダル ネガティブコールバック
     */
    removeNegativeCallback () {},
    /**
     * 削除確認モーダル ポジティブコールバック
     */
    removePositiveCallback () {
      this.destroyRecycleDisposedItem({ id: this.targetId }).then(() => {
        this.$emit('register')
      })
    },
  }
}
</script>

<style scoped>
</style>
